import React from "react";
import Navbar from "../navbar/Navbar";
import AppSidebar from "./AppSidebar";

export default function SidebarWrapper({ children }) {
  return (
    <div className="relative flex h-[100dvh] w-full overflow-hidden p-0 md:gap-4 md:p-4">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundColor: "#f6f4fb",
          backgroundImage:
            "radial-gradient(at 0% 0%, rgba(64, 48, 155, 0.12) 0px, transparent 40%), radial-gradient(at 100% 0%, rgba(240, 138, 0, 0.15) 0px, transparent 34%), radial-gradient(at 0% 100%, rgba(20, 148, 71, 0.12) 0px, transparent 34%), radial-gradient(at 100% 100%, rgba(44, 33, 111, 0.08) 0px, transparent 36%)"
        }}
      />

      <AppSidebar />

      <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Navbar />
        <div className="mt-4 flex-1 overflow-y-auto px-4 pb-4 md:px-0">{children}</div>
      </main>
    </div>
  );
}
